module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_014.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_014.png
// module id = 937
// module chunks = 0